import React, {} from "react"

const paths = require('../../../paths.json');

export default function getSubpopupInfo(influencer, currency) {
   const form_data = new FormData();
   form_data.append('influencer', influencer)
   form_data.append('currency', currency)
   this.get_and_post_data_skeleton(
      paths.BACKEND_URL + "api/subpopup_info/",
      'post',
      false,
      form_data,
      this.postSubpopupInfo,
   )
}
